module.exports = __webpack_public_path__ + "img/skypets-1.5bfd8fc5.webp";